/** @format */

import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import documentsActions from '../state/documentsActions';
import casesActions from 'src/ui/features/Cases/state/casesActions';
import { DocumentsTablePres } from '../presentational';
import { DocumentsHeader } from 'src/ui/features/Documents/presentational';
import { ConfirmDialog } from 'src/ui/library/Dialog';
import Toast from 'src/ui/library/Toast';
import { selectItemInArrays, createRowMap } from 'src/helpers';
import { DOCUMENTS_DETAIL_URL } from 'src/constants/constants.js';
import {
  getUserRolesSelector,
  getUserInfoSelector,
  isEYProSelector,
  isApplicantSelector,
  isCorpClientSelector,
} from 'src/ui/features/Login/state/loginReselect';
import { addToHistory } from 'src/utils/utilsActions';
import intl from 'react-intl-universal';
import axios from 'axios';

const CancelToken = axios.CancelToken;

class DocumentsTableContainer extends React.Component {
  constructor(props) {
    super(props);
    this.cancelTokenFn = null;
  }

  onDocumentsSearch = event => {
    this.setState({ searchDocumentText: event.target.value }, () => {
      this.getDocumentsFromBE();
      if (this.state.searchDocumentText === '') {
        this.setState({ resetPageToZero: false });
      } else {
        this.options.pageNumber = 1;
        this.setState({ resetPageToZero: true });
      }
    });
  };

  getDocumentsFromBE = () => {
    if (this.cancelTokenFn !== null) {
      this.cancelTokenFn();
    }
    let config = {
      ...this.options,
      pageNumber: 1,
      searchText: this.state.searchDocumentText || '',
    };

    if (this.props.isCase) {
      config = {
        ...config,
        caseManagerId: parseInt(this.props.caseManagerId, 10),
      };
    }

    return this.props.getDocuments(config, {
      cancelToken: new CancelToken(c => {
        this.cancelTokenFn = c;
      }),
    });
  };

  state = {
    openDialog: false,
    documents: [],
    rowIndex: null,
    page: 100,
    searchDocumentText: '',
    resetPageToZero: false,
    isLoading: false,
  };

  options = {
    pageNumber: 1,
    pageSize: this.props.isCase ? 150 : 25,
    sortDirection: 'desc',
    sortColumn: 'dateUploaded',
    filter: true,
    searchText: '',
  };

  pageSize = 0;

  async componentDidMount() {
    this.setState({ isLoading: true });
    await this.getDocuments();
    this.setState({ isLoading: false });
  }

  getZipDocuments = async () => {
    this.setState({ isLoading: true });
    await this.props.getDownloadZipDocuments(this.props.caseManagerId);
    this.setState({ isLoading: false });
    this.getDocuments();
  };

  getExecSPAPI = async () => {
    this.setState({ isLoading: true });
    await this.props.getExecuteSPAPI();
    this.setState({ isLoading: false });
  };

  getDocuments = async () => {
    let config = {
      ...this.options,
      isCase: this.props.isCase
    };

    if (this.props.isCase) {
      config = {
        ...config,
        caseManagerId: parseInt(this.props.caseManagerId, 10),
      };
    }
    await this.props.getDocuments(config);
    await this.props.getFilters(config);
    await this.props.addToHistory(window.location.pathname);
    await this.props.clearDetails();
  };

  // selectViewDetails() {
  //   this.props.getDocumentDetails();
  // }

  setDocumentDetails = (index, cmId, caseDocumentTypeId, documentTypeId, documentGroupId) => {
    //const { history, docsTableData, getDocumentDetails, storeCaseManagerId } = this.props;
    const { history, docsTableData, storeCaseManagerId } = this.props;
    let row = selectItemInArrays(index, docsTableData.caseDocuments);
    if (row.documentId !== 0) {
      let pathname = cmId
        ? cmId + '/' + row.documentId + '/' + caseDocumentTypeId + '/' + row.documentTypeId + '/' + row.documentGroupId
        : row.documentId + '/' + caseDocumentTypeId;
      storeCaseManagerId(cmId);
      history.push(`${DOCUMENTS_DETAIL_URL + '/' + pathname}`);
      // getDocumentDetails(row.documentId, row.documentTypeId, () => {
      //   history.push(`${DOCUMENTS_DETAIL_URL + '/' + pathname}`);
      // });
    }
  };

  openDocument = async id => {
    await this.props.getDocument(id);
  };

  hideConfirm = () => {
    this.setState({
      openDialog: !this.state.openDialog,
    });
  };

  setDocumentDelete = (docsTableData, tableMeta) => {
    const { caseDocuments } = docsTableData;
    const { origRowIndex } = tableMeta;

    this.setState({
      documents: caseDocuments,
      rowIndex: origRowIndex,
      openDialog: !this.state.openDialog,
    });
  };

  handleDocumentDelete = () => {
    let { documents, rowIndex } = this.state;
    const { deleteDocument } = this.props;

    deleteDocument(
      documents ? documents[rowIndex].documentId : null,
      documents ? documents[rowIndex].caseDocumentTypeId : null,
      intl.get('documents.notifications.documentDeleted'),
      this.getDocumentsFromBE,
      this.props.decrementDocCount ? this.props.decrementDocCount() : () => true,
    );
    this.setState(
      {
        openDialog: !this.state.openDialog,
      },
      () => this.getDocuments(),
    );
  };

  onTableChange = (actionType, data) => {
    const { caseDocuments, messages } = this.props.docsTableData;
    const { isApplicant, isCase } = this.props;

    switch (actionType) {
      case 'changeSort':
        const {
          sortedBy: { id, sortDirection },
        } = data;
        this.options = {
          ...this.options,
          caseManagerId: isCase ? parseInt(this.props.caseManagerId, 10) : 0,
          sortColumn: id,
          sortDirection: sortDirection,
        };

        this.props.getDocuments(this.options);
        break;
      case 'cellClick':
        const cellOpenDocument = 5;
        const {
          cellClicked: { colIndex, origRowIndex },
          model: { columns, rows },
        } = data;
        if (!this.props.isCasesDocument || (colIndex !== 0 && colIndex !== 1 && colIndex !== 2)) {
          const { caseManagerId } = createRowMap(columns, rows[origRowIndex]);
          const documentId = caseDocuments ? caseDocuments[origRowIndex].documentId : messages[origRowIndex].documentId;
          const caseDocumentTypeId = caseDocuments[origRowIndex].caseDocumentTypeId;

          if (documentId && documentId !== undefined && caseDocumentTypeId !== undefined) {
            if (colIndex === cellOpenDocument) this.openDocument(documentId);
            else if (!isApplicant) this.setDocumentDetails(origRowIndex, caseManagerId, caseDocumentTypeId);
          }
        }

        break;
      case 'changePage':
        const {
          state: { page },
        } = data;
        this.options = {
          ...this.options,
          caseManagerId: isCase ? parseInt(this.props.caseManagerId, 10) : 0,
          pageNumber: page + 1,
          searchText: this.state.searchDocumentText,
        };
        this.props.getDocuments(this.options);
        break;
      default:
        return {};
    }
  };

  containerRef = React.createRef();

  render() {
    const {
      docsTableData,
      toastMessage,
      showToastMessage,
      hideNotificationSuccess,
      isCase,
      caseManagerId,
      clientId,
      caseClosed,
    } = this.props;

    return (
      <Fragment>
        {showToastMessage && <Toast message={toastMessage} onDismiss={hideNotificationSuccess} />}
        {this.state.openDialog && (
          <ConfirmDialog
            open
            title={intl.get('documents.confirmDelete.title')}
            cancelText={intl.get('documents.confirmDelete.cancel')}
            confirmText={intl.get('documents.confirmDelete.delete')}
            onCancel={this.hideConfirm}
            onConfirm={this.handleDocumentDelete}>
            <span>{intl.get('documents.confirmDelete.messageText')}</span>
          </ConfirmDialog>
        )}
        <DocumentsHeader
          isCase={isCase}
          getZipDocuments={this.getZipDocuments}
          isLoading={this.state.isLoading}
          history={this.props.history}
          caseManagerId={caseManagerId}
          clientId={clientId}
          caseClosed={caseClosed}
          {...this.props}
        />
        {docsTableData && (
          <DocumentsTablePres
            showDropDown={docsTableData.showDropDown}
            ChangeUploadStatus={this.props.ChangeUploadStatus}
            uploadStatusList={docsTableData.uploadStatusList}
            isLoading={this.state.isLoading}
            getExecSPAPI={this.getExecSPAPI}
            onDocumentsSearch={this.onDocumentsSearch}
            setDocumentDetails={this.setDocumentDetails}
            openDocument={this.openDocument}
            containerRef={this.containerRef}
            onTableChange={this.onTableChange}
            page={this.state.page}
            resetPageToZero={this.state.resetPageToZero}
            setDocumentDelete={this.setDocumentDelete}
            totalRows={this.props.docsTableData.total}
            searchDocumentText={this.state.searchDocumentText}
            {...this.props}
          />
        )}
      </Fragment>
    );
  }
}

const mapStateToProps = state => {
  return {
    docsTableData: state.documents.tableData,
    showToastMessage: state.documents.showToastMessage,
    toastMessage: state.documents.toastMessage,
    data: state.cases.tableData,
    emails: state.emails,
    userInfo: getUserInfoSelector(state),
    userRoles: getUserRolesSelector(state),
    isEYPro: isEYProSelector(state),
    isApplicant: isApplicantSelector(state),
    isCorpClient: isCorpClientSelector(state),
    caseDetails: state.cases.caseDetails,
    frequencyList: state.cases.frequencyList,
    isUSAdminwithDeleteRights: state.documents.filters.isUSAdminwithDeleteRights,
  };
};

const mapDispatchToProps = {
  getDocuments: documentsActions.getDocuments,
  getDocument: documentsActions.getDocument,
  deleteDocument: documentsActions.deleteDocument,
  getDocumentDetails: documentsActions.getDocumentDetails,
  showNotificationSuccess: documentsActions.showNotificationSuccess,
  hideNotificationSuccess: documentsActions.hideNotificationSuccess,
  getFilters: documentsActions.getFilters,
  clearDetails: documentsActions.deHydrateDocumentDetails,
  addToHistory,
  storeCaseManagerId: documentsActions.storeCaseManagerId,
  storeCaseDetails: casesActions.getCaseDetailSuccess,
  getDownloadZipDocuments: documentsActions.getDownloadZipDocuments,
  getExecuteSPAPI: documentsActions.getExecuteSPAPI,
};

export default connect(mapStateToProps, mapDispatchToProps)(DocumentsTableContainer);



// WEBPACK FOOTER //
// ./src/ui/features/Documents/containers/DocumentsTableContainer.js